import { fabric } from "fabric";
import { getMinScaleForMaskedObject } from "./helpers/object";

export const CollageDropRegion = fabric.util.createClass(fabric.Rect, {
  initialize: function(x, y, color) {
    this.callSuper("initialize", x, y);
    this.color = color || "#3333";
  },
  toString: function() {
    return this.callSuper("toString") + " (color: " + this.color + ")";
  },
  _render: function(ctx) {
    this.callSuper("_render", ctx);

    ctx.font = "20px Helvetica";
    ctx.fillStyle = "#333";
    ctx.fillText("Test", -this.width / 2, -this.height / 2 + 20);
  }
});

export default class Collage {
  dragMask;

  constructor(canvas) {
    this.canvas = canvas;
    this.enableCollageFeatures();
  }

  enableCollageFeatures = () => {
    this.canvas.on({
      "mouse:dblclick": this.handleMaskDoubleClick,
      "object:moving": this.handleMaskMoving,
      "object:scaling": this.handleMaskMoving,
      "object:rotating": this.handleMaskMoving
    });
    this.canvas.on("object:moving", this.handleSpaning);
    this.canvas.on("object:moving", this.handleMaskedImageMoving);
    this.canvas.on("object:scaling", this.handleMaskedImageMoving);
    this.canvas.on("object:rotating", this.handleMaskedImageMoving);
    this.canvas.on("object:removed", this.handleObjectRemoved);
    this.canvas.on("before:render", this.handlePaddingUpdate);

    this.canvas.on("selection:cleared", this.handleSelectionChanges);
    this.canvas.on("selection:updated", this.handleSelectionChanges);

    this.canvas.on("mouse:move", this.handleDragging);
    this.canvas.on("mouse:down", this.handleDragStart);
    this.canvas.on("mouse:up", this.handleDrop);

    this.canvas.on("dragover", this.handleDragging);
  };

  disableCollageFeatures = () => {
    this.canvas.off({
      "mouse:dblclick": this.handleMaskDoubleClick,
      "object:moving": this.handleMaskMoving,
      "object:scaling": this.handleMaskMoving,
      "object:rotating": this.handleMaskMoving
    });
    this.canvas.off("object:moving", this.handleSpaning);
    this.canvas.off("object:moving", this.handleMaskedImageMoving);
    this.canvas.off("object:moving", this.handleMaskedImageMoving);
    this.canvas.off("object:scaling", this.handleMaskedImageMoving);
    this.canvas.off("before:render", this.handlePaddingUpdate);
    this.canvas.off("object:removed", this.handleObjectRemoved);

    this.canvas.off("selection:cleared", this.handleSelectionChanges);
    this.canvas.off("selection:updated", this.handleSelectionChanges);

    this.canvas.off("mouse:move", this.handleDragging);
    this.canvas.off("mouse:down", this.handleDragStart);
    this.canvas.off("mouse:up", this.handleDrop);

    this.canvas.off("dragover", this.handleDragging);
  };

  handleDragStart = e => {
    if (e.e.buttons !== 1) {
      return;
    }
    const obj = this.canvas.getActiveObject();
    if (obj && obj.mask) {
      this.dragMask = obj;
    } else {
      this.dragMask = null;
    }
  };

  findMaskByPoint = point => {
    return this.canvas
      .getObjects()
      .find(obj => obj.mask && obj.containsPoint(point, null, true, true));
  };

  handleDragging = e => {
    const dragMask = this.dragMask;
    const canvas = this.canvas;
    if (dragMask || e.e.dataTransfer) {
      const targetMask = this.findMaskByPoint(canvas.getPointer(e.e));
      if (!targetMask || targetMask === this.dragMask) {
        return;
      }
      canvas.getObjects().forEach(obj => {
        if (obj.mask) {
          obj.opacity = 1;
        }
      });
      targetMask.opacity = 0.65;
      canvas.requestRenderAll();
    }
  };

  handleDrop = e => {
    const canvas = this.canvas;
    canvas.getObjects().forEach(obj => {
      if (obj.mask) {
        obj.opacity = 1;
      }
    });
    if (!this.dragMask) {
      return;
    }
    const targetMask = this.canvas.findTarget(e.e);
    const srcMask = this.dragMask;
    if (!targetMask || !targetMask.mask || targetMask === srcMask) {
      this.dragMask = null;
      this.canvas.requestRenderAll();
      return;
    }
    const srcImg = this.canvas.getObjects().find(o => srcMask.id === o.clipId);
    if (!srcImg) {
      this.dragMask = null;
      this.canvas.requestRenderAll();
      return;
    }
    const targetImg = this.canvas
      .getObjects()
      .find(o => targetMask.id === o.clipId);
    if (targetImg) {
      srcMask.absolutePositioned = true;
      targetImg.clipId = srcMask.id;
      targetImg.clipPath = srcMask;
      targetImg.setPositionByOrigin(
        srcMask.getCenterPoint(),
        "center",
        "center"
      );
      targetImg.setCoords();
      const maskIndex = canvas.getObjects().findIndex(obj => obj === srcMask);
      if (maskIndex > -1) {
        targetImg.moveTo(maskIndex + 1);
      }
    }
    targetMask.absolutePositioned = true;
    srcImg.clipId = targetMask.id;
    srcImg.clipPath = targetMask;
    srcImg.setPositionByOrigin(targetMask.getCenterPoint(), "center", "center");
    srcImg.setCoords();
    const maskIndex = canvas.getObjects().findIndex(obj => obj === targetMask);
    if (maskIndex > -1) {
      srcImg.moveTo(maskIndex + 1);
    }
    this.canvas.setActiveObject(targetMask);
    console.log(srcMask, targetMask, srcImg);
    this.dragMask = null;
    this.canvas.requestRenderAll();
  };

  handleObjectRemoved = e => {
    const obj = e.target;
    const canvas = this.canvas;
    if (obj && obj.mask) {
    const maskedImage = canvas
      .getObjects()
      .find(o => obj.id === o.clipId);
      canvas.remove(maskedImage);
    }
  };

  handlePaddingUpdate = e => {
    this.canvas.getObjects().forEach(obj => {
      if (obj.snap !== undefined) {
        obj.padding = obj.snap * this.canvas.getZoom();
      }
    });
  };

  handleMaskDoubleClick = e => {
    const obj = this.canvas.getActiveObject();
    if (!obj || !obj.mask) {
      return;
    }
    const clipedObj = obj.canvas.getObjects().find(o => obj.id === o.clipId);
    if (!clipedObj) {
      return;
    }
    clipedObj.selectable = true;
    clipedObj.evented = true;
    this.canvas.setActiveObject(clipedObj);
  };

  handleSelectionChanges = e => {
    const objs = e.deselected;
    if (!objs || !objs.length) {
      return;
    }
    objs.forEach(obj => {
      if (obj.mask) {
        obj.evented = true;
        obj.selectable = true;
      }
      if (obj.clipId) {
        obj.selectable = false;
        obj.evented = false;
      }
    });
  };

  handleMaskedImageMoving = e => {
    const obj = e.target;
    if (!obj || !obj.clipId) {
      return;
    }
    const clip = obj.canvas.getObjects().find(o => o.id === obj.clipId);
    if (!clip) {
      return;
    }
    const minScale = getMinScaleForMaskedObject(obj);
    if (obj.scaleX < minScale) {
      obj.set({ scaleX: minScale, scaleY: minScale });
    }
    obj.setCoords();
    const {
      left: clipLeft,
      top: clipTop,
      width: clipWidth,
      height: clipHeight
    } = clip.getBoundingRect(true, true);
    const { left, top, width, height } = obj.getBoundingRect(true, true);
    if (left > clipLeft) {
      obj.left = clipLeft + width / 2;
    }
    if (top > clipTop) {
      obj.top = clipTop + height / 2;
    }
    const right = left + width;
    const clipRight = clipLeft + clipWidth;
    if (right < clipRight) {
      obj.left = clipRight - width / 2;
    }
    const bottom = top + height;
    const clipBottom = clipTop + clipHeight;
    if (bottom < clipBottom) {
      obj.top = clipBottom - height / 2;
    }
    obj.setCoords();
  };

  handleMaskMoving = e => {
    const obj = e.target;
    if (!obj || !obj.mask || !e.e) {
      return;
    }
    const clipObj = obj.canvas.getObjects().find(o => obj.id === o.clipId);
    if (!clipObj) {
      return;
    }
    const zoom = this.canvas.getZoom();
    const pos = clipObj.getCenterPoint();
    pos.x += e.e.movementX / zoom;
    pos.y += e.e.movementY / zoom;
    console.log(e.e.movementX, e.e.movementY);
    clipObj.setPositionByOrigin(pos, "center", "center");
    clipObj.setCoords();
  };

  handleSpaning(options) {
    const findNewPos = (distX, distY, target, obj) => {
      // See whether to focus on X or Y axis
      const snap = obj.snap ? obj.snap : 0;
      const targetSnap = target.snap ? target.snap : 0;
      const additionalShift = 0.01 + snap + targetSnap;
      const padding = snap + targetSnap;
      if (Math.abs(distX) > Math.abs(distY)) {
        if (distX > padding) {
          target.setLeft(obj.left - target.getScaledWidth() - additionalShift);
        } else {
          target.setLeft(obj.left + obj.getScaledWidth() + additionalShift);
        }
      } else {
        if (distY > padding) {
          target.setTop(obj.top - target.getScaledHeight() - additionalShift);
        } else {
          target.setTop(obj.top + obj.getScaledHeight() + additionalShift);
        }
      }
    };

    const activeObj = options.target;
    const canvas = options.target.canvas;
    if (!canvas) return;
    if (typeof options.e === "undefined") {
      return;
    }
    if (!options.e.altKey) {
      return;
    }
    const setTop = top => {
      top !== undefined && activeObj.set("top", top);
    };
    const setLeft = left => {
      left !== undefined && activeObj.set("left", left);
    };

    activeObj.setCoords();
    const snap = activeObj.snap ? activeObj.snap : 0;
    const canvasWidth = canvas.cutW + 6;
    const canvasHeight = canvas.cutH + 6;
    let { left, top, width, height } = activeObj.getBoundingRect(true, true);
    left < snap && setLeft(snap);
    top < snap && setTop(snap);
    left + width > canvasWidth - snap && setLeft(canvasWidth - width - snap);
    top + height > canvasHeight - snap && setTop(canvasHeight - height - snap);

    canvas
      .getObjects()
      .filter(o => o.excludeFromExport === false)
      .forEach(function(obj) {
        if (obj === activeObj) return;
        // If objects intersect
        if (
          activeObj.isContainedWithinObject(obj) ||
          activeObj.intersectsWithObject(obj) ||
          obj.isContainedWithinObject(activeObj)
        ) {
          const distY =
            (obj.top + obj.getScaledHeight()) / 2 - (top + height) / 2;
          const distX =
            (obj.left + obj.getScaledWidth()) / 2 - (left + width) / 2;
          findNewPos(distX, distY, activeObj, obj);
        }
      });
    activeObj.setCoords();
  }

  handleMaskDragEnter = e => {
    e.target.opacity = 0.8;
    this.canvas.requestRenderAll();
  };

  handleMaskDrop = e => {
    e.target.opacity = 1;
    this.canvas.requestRenderAll();
  };

  handleMaskDragLeave = e => {
    if (!e.target) {
      return;
    }
    e.target.opacity = 1;
    this.canvas.requestRenderAll();
  };

  disableEdit = () => {
    //FIXME: shound not effect when user disabled image
    const maskedObjects = this.canvas.getObjects().filter((obj) => obj.mask);
    maskedObjects.forEach((obj) =>
      obj.set({
        lockMovementX: true,
        lockMovementY: true,
        hasRotationPoint: false,
        hasControls: false,
        selectable: true,
      })
    );
  };
}
